export default __webpack_public_path__ + "static/media/acv-logo_zh-CN.cf2f6d20.png";